// @flow
import $ from 'jquery'
import _ from 'lodash'
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: ${({ on }) => (on ? 'block' : 'none !important')};
  position: absolute;
  background-color: rgba(0, 150, 255, 0.3);
  border: dashed 1px white;
  display: block;
  z-index: 1000;
`

type Props = {| onSelect?: Function, mouseDownSelector: string |}

type State = {| showFrame: boolean, x1: number, y1: number, x2: number, y2: number |}

export default class RectArea extends Component<Props, State> {
  mousedownFn: Function
  mousemoveFn: Function
  mouseupFn: Function
  area: any

  constructor(props: Props) {
    super(props)

    this.mousedownFn = (...args) => this.mousedown(...args)
    this.mousemoveFn = (...args) => this.mousemove(...args)
    this.mouseupFn = (...args) => this.mouseup(...args)

    this.state = { showFrame: false, x1: 0, y1: 0, x2: 0, y2: 0 }
  }

  render() {
    return (
      <Wrapper
        on={this.state.showFrame}
        ref={(el) => {
          this.area = el
        }}
      />
    )
  }

  componentDidMount() {
    $(this.props.mouseDownSelector).mousedown(this.mousedownFn)
    $(document).mousemove(this.mousemoveFn)
    $(document).mouseup(this.mouseupFn)
  }

  componentWillUnmount() {
    let rectArea = $(this.area)
    rectArea.off('mousedown', this.mousedownFn)
    $(document).off('mousemove', this.mousemoveFn)
    $(document).off('mouseup', this.mouseupFn)
  }

  componentDidUpdate() {
    const rectArea: any = $(this.area)

    rectArea.offset({
      left: Math.min(this.state.x1, this.state.x2),
      top: Math.min(this.state.y1, this.state.y2)
    })
    rectArea.width(Math.abs(this.state.x1 - this.state.x2))
    rectArea.height(Math.abs(this.state.y1 - this.state.y2))
  }

  mousedown(e: any) {
    let x = e.clientX + this.scrollLeft()
    let y = e.clientY + this.scrollTop()

    this.setState({ showFrame: true, x1: x, y1: y, x2: x, y2: y })
  }

  mousemove(e: any) {
    if (!this.state.showFrame) return

    if (e.which !== 1) {
      setTimeout(() => this.setState({ showFrame: false }), 100) // To prevent reset before mouse up
    }

    this.setState({ x1: e.clientX + this.scrollLeft(), y1: e.clientY + this.scrollTop() })
  }

  mouseup() {
    if (!this.state.showFrame) return

    this.props.onSelect &&
      this.props.onSelect(this.state.x1, this.state.y1, this.state.x2, this.state.y2)
    this.setState({ showFrame: false })
  }

  scrollLeft() {
    return _.sum(
      _.map(
        $(this.props.mouseDownSelector)
          .eq(0)
          .parents(),
        (el) => $(el).scrollLeft()
      )
    )
  }

  scrollTop() {
    return _.sum(
      _.map(
        $(this.props.mouseDownSelector)
          .eq(0)
          .parents(),
        (el) => $(el).scrollTop()
      )
    )
  }
}
